/* src/app/old-settings/edit-call-log-settings/edit-call-log-settings.component.scss */
/*# sourceMappingURL=edit-call-log-settings.component-PNBXZU5N.css.map */
